import { gql } from "@apollo/client"

export const ClaimAccountPromoCode = gql`
  mutation ClaimAccountPromoCode($input: V2ClaimAccountPromoCodeInput!) {
    v2ClaimAccountPromoCode(input: $input) {
      errors
    }
  }
`
